import React from "react";
import { Route } from "react-router-dom";

import * as Modal from "components/Modal";
import DomainMultiplierModal from "components/common/DomainMultiplierModal";

import * as ApiKeyManagementRoute from "v2/api-key-management/routes/ApiKeyManagementRoute";
import * as NewApiKeyConfirmationRoute from "v2/api-key-management/routes/NewApiKeyConfirmationRoute";
import * as DeleteApiKeyConfirmationRoute from "v2/api-key-management/routes/DeleteApiKeyConfirmationRoute";


export default function GlobalModals() {
  return [
    ...ApiKeyManagementModals(),

    <Route
      key="book-sales-call"
      path="book-sales-call"
      element={ <Modal.BookSalesCallModal /> }
    />,

    <Route
      key="change-password"
      path="change-password"
      element={ <Modal.ChangePasswordModal /> }
    />,

    <Route
      key="domain-multiplier"
      path="domain-multiplier"
      element={ <DomainMultiplierModal /> }
    />,

  ];
};

export function ApiKeyManagementModals() {
  return [
    <Route
      key={ ApiKeyManagementRoute.path }
      path={ ApiKeyManagementRoute.path }
      Component={ ApiKeyManagementRoute.Component }
    >
      <Route
        path={ NewApiKeyConfirmationRoute.path }
        Component={ NewApiKeyConfirmationRoute.Component }
      />
      <Route
        path={ DeleteApiKeyConfirmationRoute.path }
        Component={ DeleteApiKeyConfirmationRoute.Component }
      />
    </Route>
  ];
}
